import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import { DossierItemType } from "dto/Dossier/DossierItemType";
import { ItemKind } from "dto/IKindItems";
import DocumentDispatchBadge from "./DocumentDispatchBadge";
import AttachmentIconComponent from "components/AttachmentIconComponent";
import LinkIcon from "assets/icons/link.svg?react";
import FolderIcon2 from "assets/icons/folder_24px.svg?react";
import DocsIcon from "assets/icons/filters/docs.svg?react";
import { getDossierItemRealFileName } from "utils/getDossierItemFileName";
import sanitizeHtml from "sanitize-html";

const NameCell: FC<Props> = ({ element, onClick }) => {

  // useEffect(() => {
  //   if (element.Id === "newFolder") {
  //     const r = apiRef.current.getRow(element.Id);
  //     if (r) {
  //       apiRef.current.startCellEditMode({ id: element.Id, field: "Label" });
  //     }
  //   }
  // }, []);

  return (
    <div
      className={`${styles.fileName} ${
        element.Type === DossierItemType.Link && styles.link
      }`}
      onClick={onClick}
    >
      <div className={styles.icon}>
        {element.Type !== DossierItemType.Link &&
          element.Type !== DossierItemType.Folder &&
          element.Type !== DossierItemType.GoogleDocs && (
            <AttachmentIconComponent
              className={styles.iconPDF}
              file={getDossierItemRealFileName(element)}
            />
          )}
        {element.Type === DossierItemType.GoogleDocs && (
          <DocsIcon className={styles.iconPDF} />
        )}
        {element.Type === DossierItemType.Link && (
          <LinkIcon className={styles.iconPDF} />
        )}
        {element.Type === DossierItemType.Folder && (
          <FolderIcon2 className={styles.iconPDF} />
        )}
      </div>
      {!element.editLabel && (
        <div
          className={styles.name}
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(
              element.Label?.length ? element.Label : element.FileName ?? ""
            ),
          }}
        ></div>
      )}
      {element.editLabel && (
        <div>todo</div>
        // <InputInline
        //   value={label}
        //   placeholder={file.FileName}
        //   onChange={commitLabel}
        //   onCancel={cancelLabelEdit}
        // ></InputInline>
      )}
      {element.Kind === ItemKind.EditorDocument && element.Id && (
        <DocumentDispatchBadge documentId={element.Id} />
      )}
    </div>
  );
};

export default NameCell;
